import React from 'react';
import ParentChildCard from './ParentChildCard';

const ParentChildTreeResponsive = ({ node, updateNode, path = [], breadcrumbData = [] }) => {
    const currentPath = [...path];
    const currentBreadcrumb = breadcrumbData.length === 0
        ? [node.qrCode]
        : [...breadcrumbData, node.qrCode];
    return (
        <li className={node.isExpand ? "imidiate-child" : ""}>
            <ParentChildCard
                updateNode={updateNode}
                node={node}
                path={currentPath}
                breadcrumbData={currentBreadcrumb} />
            {node.children && node.children.length > 0 && (
                <ul>
                    {node.children.map((child, index) => (
                        <ParentChildTreeResponsive
                            key={child.qrCode}
                            node={child}
                            updateNode={updateNode}
                            path={[...currentPath, index]}
                            breadcrumbData={currentBreadcrumb} />
                    ))}
                </ul>
            )}
        </li>
    )
};

export default ParentChildTreeResponsive;